import { Pipe, PipeTransform } from '@angular/core';
import { round } from 'lodash';

@Pipe({
  name: 'round',
  standalone: true,
})
export class RoundPipe implements PipeTransform {
  public transform(value: number, precision?: number): number {
    return round(value, precision);
  }
}
